module.exports = __webpack_public_path__ + "static/media/cross-white.5e1ff4fc.svg";